import React, { useState } from 'react';
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Box,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add'; // Plus icon
import RemoveIcon from '@mui/icons-material/Remove'; // Minus icon (for expanded state)

const Resources = () => {
  const [expandedIndex, setExpandedIndex] = useState(null); // Track which item is expanded

  const resources = [
    {
      title: 'Understanding Gender-Based Violence',
      content: [
        'Gender-based violence (GBV) refers to harmful acts directed at an individual based on their gender. It is rooted in gender inequality, the abuse of power, and harmful norms.',
        'GBV can take many forms, including physical, sexual, emotional, and economic abuse.',
        'Learn more about the types of GBV, its impact on survivors, and how to recognize the signs.',
      ],
    },
    {
      title: 'How to Seek Help',
      content: [
        'If you or someone you know is experiencing gender-based violence, it’s important to seek help immediately. Steps to take include:',
        '1. Contact local helplines or hotlines for support.',
        '2. Reach out to trusted friends, family, or community members.',
        '3. Visit a nearby shelter or safe space.',
        '4. Report the incident to authorities or use platforms like FemiZero to file an anonymous report.',
        '5. Seek counseling or therapy to address emotional trauma.',
      ],
    },
    {
      title: 'Legal Rights and Support',
      content: [
        'Survivors of gender-based violence have legal rights that protect them from further harm. These rights include:',
        '- The right to file a police report.',
        '- The right to obtain a protection order.',
        '- The right to access free or low-cost legal representation.',
        '- The right to seek compensation for damages.',
        'Learn more about your legal options and how FemiZero can connect you with legal professionals.',
      ],
    },
    {
      title: 'Preventing Female Genital Mutilation (FGM)',
      content: [
        'Female Genital Mutilation (FGM) is a harmful practice that involves the partial or total removal of external female genitalia. It has no health benefits and can cause severe physical and psychological consequences.',
        'Learn about:',
        '- The cultural and social factors behind FGM.',
        '- The health risks associated with FGM.',
        '- How to advocate for the eradication of FGM in your community.',
      ],
    },
    {
      title: 'Counseling and Emotional Support',
      content: [
        'Survivors of gender-based violence often experience emotional trauma, anxiety, and depression. Counseling can help survivors:',
        '- Process their experiences in a safe environment.',
        '- Develop coping mechanisms for trauma.',
        '- Rebuild their self-esteem and confidence.',
        'FemiZero provides access to professional counselors who specialize in trauma recovery.',
      ],
    },
    {
      title: 'Community Support Groups',
      content: [
        'Joining a support group can provide a sense of community and shared understanding. Benefits include:',
        '- Sharing experiences with others who have faced similar challenges.',
        '- Receiving emotional support and encouragement.',
        '- Learning about resources and strategies for healing.',
        'FemiZero hosts online and in-person support groups for survivors of GBV.',
      ],
    },
    {
      title: 'Safety Planning for Survivors',
      content: [
        'A safety plan is a personalized, practical plan to improve your safety while experiencing or leaving an abusive relationship. Steps include:',
        '1. Identifying safe places to go in an emergency.',
        '2. Keeping important documents and emergency contacts in a secure location.',
        '3. Informing trusted individuals about your situation.',
        '4. Using technology safely to avoid being tracked.',
      ],
    },
    {
      title: 'Raising Awareness About Femicide',
      content: [
        'Femicide is the intentional killing of women and girls because of their gender. It is the most extreme form of gender-based violence.',
        'Learn about:',
        '- The global prevalence of femicide.',
        '- Strategies to prevent femicide in your community.',
        '- How to advocate for stronger laws and policies to protect women and girls.',
      ],
    },
    {
      title: 'Using Technology for Safety',
      content: [
        'Technology can be a powerful tool for enhancing safety and accessing support. FemiZero offers features like:',
        '- Anonymous reporting of incidents.',
        '- AI-powered chatbots for 24/7 support.',
        '- Augmented reality (AR) simulations for safety planning.',
        '- Blockchain technology to secure legal records.',
      ],
    },
    {
      title: 'Advocacy and Policy Change',
      content: [
        'Advocacy plays a crucial role in ending gender-based violence. Learn how you can:',
        '- Advocate for stronger laws and policies to protect survivors.',
        '- Raise awareness about GBV in your community.',
        '- Support organizations working to end GBV and femicide.',
      ],
    },
  ];

  const handleClick = (index) => {
    if (expandedIndex === index) {
      setExpandedIndex(null); // Collapse if already expanded
    } else {
      setExpandedIndex(index); // Expand the clicked item
    }
  };

  return (
    <Container sx={{ pb: 10 }}> {/* Add padding-bottom to prevent content from being hidden behind the footer */}
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
        Educational Resources
      </Typography>
      <List>
        {resources.map((resource, index) => (
          <React.Fragment key={index}>
            <ListItem button onClick={() => handleClick(index)}>
              <ListItemIcon>
                {expandedIndex === index ? <RemoveIcon /> : <AddIcon />}{' '}
                {/* Toggle between plus and minus icons */}
              </ListItemIcon>
              <ListItemText primary={resource.title} />
            </ListItem>
            <Collapse in={expandedIndex === index} timeout="auto" unmountOnExit>
              <Box sx={{ pl: 4, pr: 2, pb: 2 }}>
                {resource.content.map((line, i) => (
                  <Typography key={i} variant="body2" sx={{ mb: 1 }}>
                    {line}
                  </Typography>
                ))}
              </Box>
            </Collapse>
          </React.Fragment>
        ))}
      </List>

      {/* Add space before the Footer */}
      <Box sx={{ mt: 4 }} /> {/* Adjust the margin-top value as needed */}

      {/* Footer Wrapper */}
<div
  style={{
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: 'white',
    paddingTop: '30px', // top padding
    marginTop: '50px',
  }}
>
</div>
    </Container>
  );
};

export default Resources;